
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { TextValueItem } from '@/models';


@Component
export default class MultiSelect extends Vue {
    @Prop({ default: [] }) dataSource!: TextValueItem[];
    @Prop({ default: [] }) initialValue!: TextValueItem[];

    filterText: string = "";
    dataSourceView: TextValueItem[] = [];
    values : TextValueItem[] =  [];

    @Watch('values', { immediate: true })
    onValueChange(): void {
        this.$emit('change', this.values || []);
    }

    created(): void {
        this.dataSourceView = this.dataSource;
        if (this.initialValue) {
           this.values = this.initialValue;
        }
    }

}
